import { formatPrice } from '../../../util/helpers'
import { removeGst } from '../../../util/removeGst'
import { DeliveryMode, OrderStatus, OrderStatusType, SalesOrder } from '../storage/types'

export enum DeliveryDisplay {
  ToBeCalculated,
  DoNotDisplay,
  DisplayShippingInfo,
}

export const getOrderDeliveryDisplay = (order?: SalesOrder): string | undefined => {
  if (order) {
    const deliveryDisplay = getDeliveryDisplay(
      order.detailedStatus,
      getAllLineStatuses(order),
      order.deliveryMode as DeliveryMode,
    )

    if (deliveryDisplay === DeliveryDisplay.DoNotDisplay) {
      return undefined
    }

    const underFreeLimit = removeGst(order.totalAmountIncGst) < 500
    const shippingAmount = formatPrice(order?.shippingAmountExcGst)

    if (deliveryDisplay === DeliveryDisplay.ToBeCalculated) {
      return underFreeLimit ? 'To be calculated' : shippingAmount
    }

    return shippingAmount
  }
  return undefined
}

const getAllLineStatuses = (order: SalesOrder): OrderStatus[] => {
  return order.salesLines.map((line) => line.detailedLineStatus as OrderStatus)
}

export const getDeliveryDisplay = (
  detailedStatus: OrderStatusType,
  detailedLineStatuses: OrderStatusType[],
  deliveryMode: DeliveryMode,
): DeliveryDisplay => {
  if (deliveryMode !== DeliveryMode.Delivery) {
    return DeliveryDisplay.DoNotDisplay
  }

  switch (detailedStatus) {
    case OrderStatus.AtDirectShipper:
    case OrderStatus.Backordered:
    case OrderStatus.InProcessing:
    case OrderStatus.OpenLine:
    case OrderStatus.PartiallyExchanged:
    case OrderStatus.ToBeDirectDelivered:
      return DeliveryDisplay.ToBeCalculated

    case OrderStatus.PartiallyPicked:
      return DeliveryDisplay.DoNotDisplay

    case OrderStatus.PartiallyInvoiced:
    case OrderStatus.PartiallyDelivered: {
      const partiallyDelivered = detailedLineStatuses.some(
        (value) => value === OrderStatus.Delivered,
      )
      const partiallyInvoiced = detailedLineStatuses.some((value) => value === OrderStatus.Invoiced)
      const partiallyReady = partiallyDelivered || partiallyInvoiced
      if (partiallyReady && deliveryMode === DeliveryMode.Delivery) {
        return DeliveryDisplay.DisplayShippingInfo
      }
      return DeliveryDisplay.ToBeCalculated
    }

    case OrderStatus.Invoiced:
    case OrderStatus.Delivered: {
      return DeliveryDisplay.DisplayShippingInfo
    }
  }
  return DeliveryDisplay.DoNotDisplay
}
